import TermsAndPoliciesSubtitle from 'pages/terms-and-policies/TermsAndPoliciesSubtitle'
import React from 'react'

type TermsAndPoliciesItemContentProps = {
  title: string
  content: string
}

const TermsAndPoliciesItemContent = ({
  title,
  content,
}: TermsAndPoliciesItemContentProps) => {
  return (
    <div className='px-[20px] md:px-[143px] py-[40px]'>
      <TermsAndPoliciesSubtitle text={title} />
      <div
        className='pt-4 md:text-[16px] text-[12px] font-light text-[#25395C] text-justify tracking-[0.4px] '
        dangerouslySetInnerHTML={{
          __html: content.replace(/&lt;meta charset="UTF-8"&gt;/g, ''),
        }}
      />
    </div>
  )
}

export default TermsAndPoliciesItemContent
